import { render, staticRenderFns } from "./DISCOBJECT.source.component.vue?vue&type=template&id=0449cc3e&"
import script from "./DISCOBJECT.source.component.vue?vue&type=script&lang=js&"
export * from "./DISCOBJECT.source.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports